import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { setSelectItem, unsetSelectItem } from "../../actions/ClientAction";
// import fileExtension from 'file-extension'
import { getImageDocumentByExtension } from "../../utils";
import PdfHover from "./HoverPdfDocument/PdfHover";
import "./document-view.css";

export class DocumentView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: "",
      listViewStyle: null,
      wasConverted: false
    };
  }

  componentDidMount() {
    const { item, from } = this.props;
    if (item) {
      //const ext = fileExtension(item.originalURL)
      let itemUrl;
      const wasConverted = item.originalURL !== item.lowQualityURL;
      if (wasConverted) {
        itemUrl = item.lowQualityURL;
      } else {
        itemUrl = getImageDocumentByExtension(item.originalURL, item);
      }
      this.setState({
        url: itemUrl,
        wasConverted: wasConverted
      });
    }

    if (from === "list") {
      this.setState({
        listViewStyle: true
      });
    } else {
      this.setState({
        listViewStyle: false
      });
    }
  }

  handleMiddleView = () => {
    const { keyCollection, indice, item, from } = this.props;
    if (keyCollection && indice && item && from && item.isSelected !== true) {
      this.props.setSelectItem(keyCollection, item, from, indice);
    } else {
      this.props.unsetSelectItem(keyCollection);
    }
  };

  render() {
    const { url, listViewStyle, wasConverted } = this.state;
    const {
      item,
      from,
      listComment,
      handleSelectExpandAsset,
      handleShowMessage,
      showDocumenHover
    } = this.props;
    let assetExtension = null;
    if (from === "middleView") {
      const splitedUrl = item && item.originalURL ? item.originalURL.split(".") : [];
      assetExtension = splitedUrl.pop();
    }

    const isAssetConverted =
      item.documentPages && item.documentPages.length > 0;
    const showNewHover =
      assetExtension &&
      assetExtension.toLowerCase() === "pdf" &&
      from === "middleView" &&
      showDocumenHover &&
      isAssetConverted;
    return (
      <React.Fragment>
        {showNewHover && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <PdfHover
              handleSelectExpandAsset={handleSelectExpandAsset}
              handleShowMessage={handleShowMessage}
            >
              <img
                onClick={this.handleMiddleView}
                className={
                  from === "middleView" ? `img-responsive` : `img-asset`
                }
                style={{
                  padding: from === "middleView" ? 0 : 10,
                  width: from === "middleView" ? "100%" : "auto",
                  maxHeight: listComment ? "60px" : ""
                }}
                src={url}
                alt={item.name}
              />
            </PdfHover>
          </div>
        )}
        {!showNewHover && from !== "comments" && !listViewStyle && item && (
          <img
            onClick={this.handleMiddleView}
            className={from === "middleView" ? `img-responsive` : `img-asset`}
            style={{
              padding: from === "middleView" ? 0 : 10,
              width:
                from === "middleView" && wasConverted
                  ? "100%"
                  : from === "middleView" && !wasConverted
                  ? "50%"
                  : "auto",
              maxHeight: listComment ? "60px" : ""
            }}
            src={url}
            alt={item.name}
          />
        )}
        {!showNewHover && from !== "comments" && listViewStyle && item && (
          <img
            onClick={this.handleMiddleView}
            className="img-asset-list"
            style={{ cursor: "pointer", height: "50px", marginLeft: "9px" }}
            src={url}
            alt={item.name}
          />
        )}

        {!showNewHover && from === "comments" && item && (
          <img
            onClick={this.handleMiddleView}
            className="document-asset-comment"
            src={url}
            alt={item.name}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setSelectItem,
  unsetSelectItem
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DocumentView))
);
